import type { SvgIconProps } from '@mui/material';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory2';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import ChairIcon from '@mui/icons-material/Chair';
import KitchenIcon from '@mui/icons-material/Kitchen';
import DevicesIcon from '@mui/icons-material/Devices';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import PetsIcon from '@mui/icons-material/Pets';
import SpaIcon from '@mui/icons-material/Spa';
import ToysIcon from '@mui/icons-material/Toys';
import BuildIcon from '@mui/icons-material/Build';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import WatchIcon from '@mui/icons-material/Watch';
import DiamondIcon from '@mui/icons-material/Diamond';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import LiquorIcon from '@mui/icons-material/Liquor';
import { CATALOGUE_ICONS, DEFAULT_CATALOGUE_ICON, type CatalogueIcon as IconKey } from '@traaker/shared';

/** Maps a catalogue icon key → its MUI icon component. Single source of truth so
 *  lists, selectors, and the create/edit dialog all render the same glyph. */
const ICON_MAP: Record<IconKey, React.ComponentType<SvgIconProps>> = {
  store: StoreIcon,
  shopping_cart: ShoppingCartIcon,
  shopping_bag: ShoppingBagIcon,
  category: CategoryIcon,
  inventory: InventoryIcon,
  local_offer: LocalOfferIcon,
  checkroom: CheckroomIcon,
  chair: ChairIcon,
  kitchen: KitchenIcon,
  devices: DevicesIcon,
  sports_soccer: SportsSoccerIcon,
  restaurant: RestaurantIcon,
  local_grocery_store: LocalGroceryStoreIcon,
  pets: PetsIcon,
  spa: SpaIcon,
  toys: ToysIcon,
  build: BuildIcon,
  directions_car: DirectionsCarIcon,
  menu_book: MenuBookIcon,
  watch: WatchIcon,
  diamond: DiamondIcon,
  local_florist: LocalFloristIcon,
  fitness_center: FitnessCenterIcon,
  liquor: LiquorIcon,
};

export const CATALOGUE_ICON_KEYS = CATALOGUE_ICONS;

/** Render a catalogue's icon (falls back to the default when unset/unknown). */
export function CatalogueIcon({ icon, ...props }: { icon?: string } & SvgIconProps) {
  const Cmp = ICON_MAP[(icon as IconKey) in ICON_MAP ? (icon as IconKey) : DEFAULT_CATALOGUE_ICON];
  return <Cmp {...props} />;
}
